export const DOWNLOAD_REPORT_TYPES =
  "daily-record,transaction-item-discount,transaction,transaction-item,detailed-transaction";

export const REPORT_UPDATED_EVENT = "report-updated";
